import React from 'react';

const TONES = {
  brand:   'bg-brand-100 text-brand-700 ring-brand-200',
  emerald: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
  sky:     'bg-sky-100 text-sky-800 ring-sky-200',
  amber:   'bg-amber-100 text-amber-800 ring-amber-200',
  rose:    'bg-rose-100 text-rose-800 ring-rose-200',
  violet:  'bg-violet-100 text-violet-800 ring-violet-200',
  gray:    'bg-gray-100 text-gray-700 ring-gray-200',
  // alias used in some prototypes
  purple:  'bg-violet-100 text-violet-800 ring-violet-200',
};

/**
 * Small tone-coded pill, re-used widely for roles, categories and counts.
 *
 * @param {Object} props
 * @param {'brand'|'emerald'|'sky'|'amber'|'rose'|'violet'|'gray'} [props.tone='gray']
 *   Semantic colour tone.
 * @param {React.ReactNode} props.children - Pill label.
 * @param {string} [props.className] - Extra classes appended to the pill.
 * @returns {JSX.Element}
 */
export default function MiniPill({ tone = 'gray', children, className = '' }) {
  const cls = TONES[tone] || TONES.gray;
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-[11.5px] font-semibold ring-1 ${cls} ${className}`}
    >
      {children}
    </span>
  );
}
